import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Check, Times } from '../../../components/Icon';
import { BaseComponent } from '../../../components/BaseComponent';

const Container = styled.div`

  > .box {
    border-bottom: 1px solid #ddd;
    min-width:600px;

    > div{
        width:150px;
        min-width:150px;
        &:first-child {
            min-width:400px;
        }
    }
  }

  .selected {
    color:green;
  }
  .not-selected { 
    color:red;
  }


  .name {
    margin-right: 12px;
    width: 200px;
    min-width: 300px;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class VehicleOptionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get selected(){
    return this.option.VehicleHasOption?.isSelected;
  }

  get option() {
    return this.props.option;
  }

  render() {
    console.dir(this.option);
    debugger;
    
    return (
      <Container>
        <HBox>
        <div> {this.option.name} ({this.option.autotelexId})</div>
        <div>{this.option.price ? `€ ${this.option.price}` : ''}</div>
        <div className={`${this.selected ? 'selected' :'not-selected'}`}>
            <b>{this.lbl('vehicle.details.options.selectedTitle')}</b>
            {this.selected === true ? <Check /> : this.selected === false ? <Times /> : '-'}
        </div>
        <div>
              <b>{this.lbl('vehicle.details.options.valueAddingOptionTitle')}</b>
            {this.option.valueAddingOption === true ? <Check /> : this.option.valueAddingOption === false ? <Times /> : '-'}
        </div>
        </HBox>
      </Container>
    );
  }
}

VehicleOptionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleOption = compose(
  withConnect,
  withRouter,
)(VehicleOptionComp);
